import { render } from "./UserProfileCard.vue?vue&type=template&id=7b65cba5&scoped=true"
import script from "./UserProfileCard.vue?vue&type=script&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&lang=js"

import "./UserProfileCard.vue?vue&type=style&index=0&id=7b65cba5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b65cba5"]])

export default __exports__